import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { allowedDataDefinitionListProps } from '../utils/allowedPropTypes';
import DataDefinitionListContent from './_DataDefinitionListContent';

const DataDefinitionListController = props => {
  const { listData } = props;

  if (Array.isArray(listData)) {
    return listData.map(dataObject => {
      const contentProps = {
        ...props,
        listData: dataObject,
        key: uuidv4()
      };

      return <DataDefinitionListContent {...contentProps} />;
    });
  }


  return <DataDefinitionListContent {...props} />;
};

DataDefinitionListController.propTypes = allowedDataDefinitionListProps;

export default DataDefinitionListController;